<template>
  <v-app-bar :color="$vuetify.theme.dark ? 'surface' : 'white'" app flat height="80" class="app-bar-wrapper"
  :class="$vuetify.breakpoint.xs ? 'px-0' : 'px-6'"
    style="position: fixed;" :elevation="0">
    <div class="app-bar-content mx-auto">
      <!-- Logo and Brand -->
      <router-link to="/" class="d-flex align-center text-decoration-none brand-link">
        <v-card color="rgb(228 255 214)" class="pa-2" style="border-radius: 16px !important; z-index: 2; position: relative;"
        flat
        >
        <v-img src="../../assets/logo.png" 
        width="42" height="42"
        max-width="42" contain class="logo-image"></v-img>
        </v-card>


        <logo class="ml-3" />

      </router-link>


      <div class="d-flex text-center justify-center" style="flex: 1;">
        <!-- Navigation Links -->
        <div class="d-none d-md-flex align-center nav-links-container">
          <v-btn v-for="(item, i) in menuItems" :key="i" text class="nav-link mx-2 text-body-1"
            @click="scrollToSection(item.id)" :ripple="false">
            {{ item.text }}
          </v-btn>
        </div>
      </div>
      <!-- Action Buttons Container -->
      <div class="d-flex align-center action-buttons">
        <!-- Theme Toggle -->
        <v-btn v-if="false" icon class="theme-toggle" @click="toggleTheme"
          :aria-label="$vuetify.theme.dark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'">
          <v-icon v-if="$vuetify.theme.dark">mdi-weather-sunny</v-icon>
          <v-icon v-else>mdi-weather-night</v-icon>
        </v-btn>


        <!-- Login Button -->
        <user-button v-if="$root.currentUser && !$vuetify.breakpoint.xs" class="ml-3"></user-button>



        <!-- Get Started Button -->
        <v-btn class="primary ml-4 get-started-btn" height="44" depressed @click="getStarted">
          <span class="btn-text">Comenzar</span>
          <v-icon right small class="ml-1 btn-icon">mdi-arrow-right</v-icon>
        </v-btn>



        <!-- Mobile Menu Button -->
        <!-- <v-btn icon class="d-md-none ml-3 menu-button" @click="$emit('toggleDrawer')" aria-label="Abrir menú">
          <v-icon>mdi-menu</v-icon>
        </v-btn> -->
      </div>
    </div>
  </v-app-bar>
</template>

<script>
import UserButton from '../../views/profile/login/UserButton.vue'
import Logo from '@/views/app/components/Logo.vue'

export default {
  name: 'AppBar',
  data: () => ({
    menuItems: [
      { text: 'Soluciones', id: 'solution' },
      { text: 'Ejemplos', id: 'examples' },
      { text: 'Precios', id: 'pricing' },
      { text: 'Testimonios', id: 'testimonials' },
      // { text: 'Blog', id: 'blog' }
    ]
  }),
  components: {
    UserButton,
    Logo
  },
  computed: {
    isLoggedIn() {
      return this.$root.isLoggedIn;
    }
  },
  methods: {
    scrollToSection(id) {
      if (this.$route.path !== '/') {
        this.$router.push('/');
        // return;
      }
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          const offset = -70;
          const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: elementPosition + offset,
            behavior: 'smooth'
          });
        }
      }, 100);
    },
    toggleTheme() {
      this.$root.isDark = !this.$root.isDark;
      this.$vuetify.theme.dark = this.$root.isDark;
      this.$cookies.set('darkMode', this.$root.isDark);
    },
    login() {
      this.$router.push({
        path: '/login',
        query: { ...this.$route.query }
      });
    },
    getStarted() {
      console.log("this.$root.currentUser", this.$root.currentUser)
      if (!this.$root.currentUser || !this.$root.currentUser.value)
        if (this.$root.currentUser)
          this.$router.push({
            path: '/login',
            query: { ...this.$route.query }
          });
        else
          this.$router.push({
            path: '/login',
            query: { 
              ...this.$route.query,
              loginStatus: false 
            }
          });
      else {
        if (this.$root.currentUser.hasInfo)
          this.$router.push('/app');
        else
          this.$router.push({
            path: '/start',
            query: { ...this.$route.query }
          });
      }
    }
  }
}
</script>

<style scoped>
.app-bar-wrapper {
  margin: 16px 24px !important;
  border-radius: 20px !important;
  background: transparent !important;
  height: 80px !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 1000 !important;
}

.app-bar-content {
  background: var(--v-background-base);
  border: 1px solid rgba(130, 177, 255, 0.1) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 20px !important;
  padding: 0 20px;
  height: 80px;
  width: 100%;
  display: flex;
  align-items: center;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.05) !important;
  transition: all 0.3s ease;
  background: linear-gradient(to bottom right,
      rgba(255, 255, 255, 0.9),
      rgba(255, 255, 255, 0.8)) !important;
  position: relative;
  max-width: 1200px;
}

.app-bar-content:hover {
  box-shadow: 0 10px 40px rgba(130, 177, 255, 0.1) !important;
  border-color: rgba(130, 177, 255, 0.15) !important;
  /* transform: translateY(-1px); */
}

.brand-link {
  position: relative;
  transition: transform 0.3s ease;
}

.brand-link:hover {
  /* No transform */
}

.logo-container {
  position: relative;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(130, 177, 255, 0.1) 0%, rgba(68, 138, 255, 0.05) 100%);
  overflow: hidden;
  transition: all 0.3s ease;
}

.brand-link:hover .logo-container {
  box-shadow: 0 4px 12px rgba(130, 177, 255, 0.15);
}

.logo-image {
  transition: all 0.3s ease;
}

.brand-link:hover .logo-image {
  /* No transform */
}

.brand-text {
  color: #4dd453;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, sans-serif !important;
  font-size: 1.7rem !important;
  font-weight: 900 !important;
  letter-spacing: -0.02;
  transition: all 0.3s ease;
}

.brand-link:hover .brand-text {
  background: linear-gradient(90deg, #4dd453, #4fee57);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.nav-links-container {
  margin: 0 16px;
}

.nav-link {
  font-size: 1rem !important;
  color: var(--v-textSecondary-base) !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: -0.01em !important;
  padding: 0 16px !important;
  min-width: 0 !important;
  height: 44px !important;
  border-radius: 12px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  margin: 0 4px !important;
  font-family: 'Nunito', sans-serif !important;
  position: relative;
  overflow: hidden;
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 3px;
  background: linear-gradient(90deg, #4dd453, #4fee57);
  transform: translateX(-50%);
  transition: width 0.3s ease;
  border-radius: 3px 3px 0 0;
  opacity: 0;
}

.nav-link:hover {
  background: rgba(88, 204, 2, 0.08) !important;
  color: #4dd453 !important;
}

.nav-link:hover::after {
  width: 30%;
  opacity: 1;
}

.action-buttons {
  display: flex;
  align-items: center;
}

.theme-toggle {
  width: 44px !important;
  height: 44px !important;
  border-radius: 12px !important;
  color: var(--v-textSecondary-base) !important;
  transition: all 0.3s ease !important;
  background: rgba(88, 204, 2, 0.05) !important;
}

.theme-toggle:hover {
  background: rgba(88, 204, 2, 0.1) !important;
  color: #4dd453 !important;
  box-shadow: 0 4px 8px rgba(88, 204, 2, 0.1) !important;
}

.get-started-btn {
  position: relative;
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: -0.01em !important;
  box-shadow: 0 4px 0 #58a700 !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  overflow: hidden;
  height: 38px !important;
  transform: translateY(0) !important;
  background: linear-gradient(90deg, #4dd453, #58cc02) !important;
}

.btn-text,
.btn-icon {
  position: relative;
  z-index: 2;
  transition: all 0.3s ease;
}

.get-started-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transform: translateX(-100%);
  transition: transform 0.6s;
  z-index: 1;
}

.get-started-btn:hover {
  filter: brightness(1.02);
  box-shadow: 0 4px 0 #58a700 !important;
  transform: translateY(0) !important;
}

.get-started-btn:active {
  box-shadow: 0 0 0 #58a700 !important;
  transform: translateY(4px) !important;
}

.get-started-btn:hover .btn-icon {
  /* No transform */
}

.menu-button {
  width: 44px !important;
  height: 44px !important;
  border-radius: 12px !important;
  color: var(--v-textSecondary-base) !important;
  transition: all 0.3s ease !important;
  background: rgba(88, 204, 2, 0.05) !important;
}

.menu-button:hover {
  background: rgba(88, 204, 2, 0.1) !important;
  color: #4dd453 !important;
  box-shadow: 0 4px 8px rgba(88, 204, 2, 0.1) !important;
}

/* Dark Theme Adjustments */
.theme--dark .app-bar-content {
  background: linear-gradient(to bottom right,
      rgba(30, 30, 30, 0.8),
      rgba(30, 30, 30, 0.7)) !important;
  border-color: rgba(88, 204, 2, 0.05) !important;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2) !important;
}

.theme--dark .app-bar-content:hover {
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3) !important;
  border-color: rgba(88, 204, 2, 0.1) !important;
}

.theme--dark .logo-container {
  background: linear-gradient(135deg, rgba(88, 204, 2, 0.15) 0%, rgba(88, 167, 0, 0.1) 100%);
}

.theme--dark .nav-link {
  color: rgba(255, 255, 255, 0.7) !important;
}

.theme--dark .nav-link:hover {
  background: rgba(88, 204, 2, 0.15) !important;
  color: rgba(88, 204, 2, 0.9) !important;
}

.theme--dark .theme-toggle,
.theme--dark .menu-button {
  color: rgba(255, 255, 255, 0.7) !important;
  background: rgba(88, 204, 2, 0.1) !important;
}

.theme--dark .theme-toggle:hover,
.theme--dark .menu-button:hover {
  background: rgba(88, 204, 2, 0.15) !important;
  color: rgba(88, 204, 2, 0.9) !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2) !important;
}

.theme--dark .login-button {
  color: rgba(255, 255, 255, 0.7) !important;
  border-color: rgba(88, 204, 2, 0.15) !important;
}

.theme--dark .login-button:hover {
  background: rgba(88, 204, 2, 0.15) !important;
  color: rgba(88, 204, 2, 0.9) !important;
  border-color: rgba(88, 204, 2, 0.25) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
}

.theme--dark .get-started-btn {
  opacity: 0.95;
}

.theme--dark .get-started-btn:hover {
  opacity: 1;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3) !important;
}

/* Responsive Adjustments */
@media (max-width: 959px) {
  .app-bar-wrapper {
    margin: 12px 16px !important;
  }

  .app-bar-content {
    padding: 0 16px;
  }

  .brand-text {
    font-size: 1.25rem !important;
  }

  .login-button {
    padding: 0 16px !important;
  }

  .get-started-btn {
    padding: 0 16px !important;
  }
}

@media (max-width: 599px) {
  .app-bar-wrapper {
    margin: 8px 8px !important;
  }

  .app-bar-content {
    padding: 0 12px;
    height: 72px;
  }

  .brand-text {
    font-size: 1.125rem !important;
  }

  .login-button {
    display: none;
  }

  .get-started-btn {
    height: 40px !important;
    font-size: 0.875rem !important;
  }

  .theme-toggle,
  .menu-button {
    width: 40px !important;
    height: 40px !important;
  }
}


.logo {
    border-radius: 10px;
    margin-left: -20px;
    outline: 1px solid;
    padding-left: 20px;
    padding-right: 6px;
    display: flex;
    border-bottom-left-radius: 0px !important;
    border-top-left-radius: 0px !important;
    border: none !important;
    outline: none !important;
}

.subscribe-btn {
    position: relative;
    border-radius: 12px !important;
    text-transform: none !important;
    font-weight: 600 !important;
    letter-spacing: -0.01em !important;
    /* box-shadow: 0 6px 0 #58a700 !important; */
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
    overflow: hidden;
    height: 39px !important;
    transform: translateY(0) !important;
    background: #29544D !important;
    box-shadow: 0 2px 0 #1F3F3A !important;
    color: white !important;
}

</style>
